module.exports = __webpack_public_path__ + "static/media/old-car-removal-beenleigh.141f78a9.png";